import React, { useCallback, useState } from 'react';
import { TopBar } from './components/TopBar';
import { Hero } from './components/Hero';
import { DateCountdownCard } from './components/DateCountdownCard';
import { SpeakerSection } from './components/SpeakerSection';
import { CurriculumSection } from './components/CurriculumSection';
import { MissionBanner } from './components/MissionBanner';
import { Testimonials } from './components/Testimonials';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { RegistrationModal } from './components/RegistrationModal';
import { StickyMobileCTA } from './components/StickyMobileCTA';
import { SocialProofToast } from './components/SocialProofToast';
export function App() {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [seatsTaken, setSeatsTaken] = useState(60); // 40 of 100 left to start
  const handleOpenModal = () => setIsModalOpen(true);
  const bumpSeats = useCallback(() => setSeatsTaken(prev => Math.min(prev + 1, 99)), []);
  return <div className="min-h-screen bg-brand-blue font-body text-white selection:bg-brand-gold selection:text-black" data-id="element-0">
      <TopBar onRegisterClick={handleOpenModal} seatsTaken={seatsTaken} data-id="element-1" />

      <main data-id="element-2">
        <Hero data-id="element-3" />
        <DateCountdownCard onRegisterClick={handleOpenModal} data-id="element-4" />
        <SpeakerSection onRegisterClick={handleOpenModal} data-id="element-5" />
        <CurriculumSection onRegisterClick={handleOpenModal} data-id="element-6" />
        <MissionBanner data-id="element-7" />
        <Testimonials data-id="element-8" />
        <FinalCTA onRegisterClick={handleOpenModal} data-id="element-9" />
      </main>

      <Footer data-id="element-10" />

      <StickyMobileCTA onRegisterClick={handleOpenModal} data-id="element-11" />

      <SocialProofToast onRegistration={bumpSeats} data-id="element-12" />

      <RegistrationModal isOpen={isModalOpen} onOpenChange={setIsModalOpen} data-id="element-13" />
    </div>;
}